import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const routeLabels = {
  '/': 'Home',
  '/services': 'Tours',
  '/birding': 'Birding Tours',
  '/itinerary': 'Sample Itinerary',
  '/lodge': 'Birding Lodge',
  '/transport': 'Transportation',
  '/hotels': 'Hotels',
  '/guide': 'Your Guide',
  '/contact': 'Contact',
  '/poasvolcano': 'Poas Volcano Tour',
  '/poasdoka': 'Poas & Doka Tour',
  '/poasmirador': 'Poas & Mirador Tour',
  '/doka': 'Doka Coffee Tour',
  '/sarchi': 'Sarchi & Grecia Tour',
  '/waterfall': 'La Paz Waterfall Tour',
  '/mirador': 'Mirador Cinchona Tour',
  '/wildlife': 'Wildlife Directory',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const path = location.pathname;

  // Don't show on homepage
  if (path === '/') return null;

  const currentLabel = routeLabels[path] || 'Page';

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Home',
        'item': 'https://ecoride.cr/',
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': currentLabel,
        'item': `https://ecoride.cr${path}`,
      },
    ],
  };

  return (
    <>
      <Helmet defer={false}>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <nav
        aria-label="Breadcrumb"
        className="max-w-7xl mx-auto px-6 md:px-16 lg:px-32 xl:px-64 py-3 text-sm"
      >
        <ol className="flex items-center space-x-2 text-gray-400">
          <li>
            <Link to="/" className="hover:text-green-400 transition-colors">
              Home
            </Link>
          </li>
          <li aria-hidden="true">/</li>
          <li>
            <span className="text-green-400 font-medium">{currentLabel}</span>
          </li>
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
